import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { IconSelArrow02 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}

const SortingBtn = ({ text, className, onClick }: IProps) => {
  const cName = classNameBind(['sorting-btn', className || '']);

  return (
    <S.SortingBtn className={cName} onClick={onClick}>
      <Text>{text}</Text>
      <span className="arrow">
        <IconSelArrow02 />
      </span>
    </S.SortingBtn>
  );
};

export default SortingBtn;
